import { useTranslation } from 'react-i18next'
import WarningIcon from '@nv/images/design/warning-icon'
import { ModalWrapper } from '../../ModalWrapper'
import SuccessQrChangeModalStyles from './SuccessQrChangeModal.module.scss'

export const SuccessQrChangeModal = (props) => {
  const { t } = useTranslation()

  const btns = [
    {
      text: t('buttons.cancel'),
      onClick: () => {
        props.onRequestClose()
      },
      isCancel: true
    },
    {
      text: t('buttons.ok'),
      onClick: () => {
        props.onClick()
      },
    },
  ]

  return (
    <ModalWrapper
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      headerLabel={t('auth.authApp.form.confirmRequest')}
      btns={btns}
    >
      <div className={SuccessQrChangeModalStyles['container']}>
        <WarningIcon className={SuccessQrChangeModalStyles['icon']} />
        <span className={SuccessQrChangeModalStyles['text']}>
          {t('auth.authApp.form.confirmRequest')}
        </span>
      </div>
    </ModalWrapper>
  )
}
